import { Modal } from 'antd';
import { useAppTranslation } from 'app/hooks';
import CloseIcon from 'assets/icons/CloseIcon';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import Typo from 'consts/typography';
import useThemes from 'hooks/useThemes';
import useUserDetail from 'hooks/useUserDetail';
import { formatDate } from 'utils/dateUtils';
import { formatMoney, formatMoneyWithoutTrunc } from 'utils/formatAmount';
import teraber_coin_logo from 'assets/images/terabet_coin_logo.png';

interface UserReferralModalProps {
  visible: boolean;
  closeModal: () => void;
  className?: string;
}

const UserReferralModal: React.FunctionComponent<UserReferralModalProps> = (props) => {
  const { visible, closeModal } = props;
  const { currentTheme } = useThemes();
  const { currentUser } = useUserDetail();
  const t = useAppTranslation();
  return (
    <Modal
      className="common-modal user-profile-modal"
      title={t('userProfile.rowInfo.referralTitle')}
      visible={visible}
      onCancel={closeModal}
      footer={null}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      width={600}
    >
      {currentUser?.affiliateUserEmail && (
        <>
          <div>
            <span className={`primary-text-color ${Typo.p3} `}>
              {t('userProfile.rowInfo.affiliateUser')}
            </span>
          </div>
          <div className="referral-history__item">
            <div className="referral-history__user">
              <p className="referral-history__name">{currentUser?.affiliateUserEmail}</p>
              <p className={`referral-history__status active`}>
                {formatDate(currentUser?.activeReferralDate)}
              </p>
            </div>
          </div>
          <div className="referral-line "></div>
        </>
      )}

      <div>
        <span className={`primary-text-color ${Typo.p3} `}>
          {t('userProfile.rowInfo.referralList')}
        </span>
      </div>
      <div className="referral-history__modal">
        {!currentUser?.referrals || currentUser?.referrals.length === 0 ? (
          <div className="empty">
            <EmptyTableIcon />
          </div>
        ) : (
          [...currentUser?.referrals]
            .sort((a, b) => Date.parse(b.createdDate) - Date.parse(a.createdDate))
            .map((referal) => (
              <div className="referral-history__item">
                <div className="referral-history__user">
                  <p className="referral-history__name">{referal.email}</p>
                  <p className={`referral-history__status active`}>
                    {formatDate(referal.createdDate)}
                  </p>
                </div>
                <div className="referral-history__amount-container">
                  <div className="referral-history__amount ">
                    <div>
                      <img src={teraber_coin_logo} width={15} /> {t('userProfile.rowInfo.reward')}:{' '}
                    </div>

                    <p>{formatMoneyWithoutTrunc(referal.amount, 2).replace('$', '')}</p>
                  </div>
                  <div className="referral-history__amount ">
                    <div>
                      <img src={teraber_coin_logo} width={15} />{' '}
                      <p>{t('userProfile.rowInfo.volume')}: </p>
                    </div>
                    <p>
                      {formatMoneyWithoutTrunc(referal.volume, 2).replace('$', '')}{' '}
                      {`(${formatMoneyWithoutTrunc(referal.rewardVolume, 2).replace('$', '')})`}
                    </p>
                  </div>
                </div>
              </div>
            ))
        )}
      </div>
    </Modal>
  );
};

export default UserReferralModal;
